module.exports = [
	{
		"type": "Source",
		"id": "Source1",
		"x": 100,
		"y": 100
	},
	{
		"type": "Separator",
		"id": "Separator2",
		"x": 100,
		"y": 200,
		"condition": "isEven"
	},
	{
		"type": "Destination",
		"id": "Destination3",
		"x": 65,
		"y": 320
	},
	{
		"type": "Cloner",
		"id": "Cloner4",
		"x": 135,
		"y": 340
	},
	{
		"type": "Combiner",
		"id": "Combiner5",
		"x": 135,
		"y": 470,
		"operation": "multiply"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/examples/squaresOfEvenNumbers.json
 ** module id = 260
 ** module chunks = 1
 **/